import styled from "styled-components";

export const ResponsiveGridLayout = styled.div`
  display: grid;
  width: 100%;
  gap: 16px;
  grid-template-columns: repeat(3, minmax(0, 1fr));

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 840px) {
    grid-template-columns: 1fr;
  }
`;
